import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useIsAdmin, useIsIsgUser } from '../utils/role';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const isIsg = useIsIsgUser();
  
  return (
    <Result
      status="403"
      title="403"
      subTitle="Üzgünüz, bu sayfaya erişim yetkiniz bulunmamaktadır."
      extra={
        <Button 
          type="primary" 
          onClick={() => {
            if(isAdmin){
              navigate('/admin/dashboard');
            } else if(isIsg){
              navigate('/isg/home');
            } else {
              navigate('/firm/home');
            }
          }}
        >
          Ana Sayfaya Dön
        </Button>
      }
    />
  );
};

export default UnauthorizedPage;